import { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { changePassword } from "../api/auth";
import { validatePassword } from "../utils/validatePassword";
import PasswordInput from "../components/PasswordInput";

export default function ProfilePage(){

  const [household, setHousehold] = useState(null);

  const [currentPw,  setCurrentPw]  = useState("");
  const [newPw,      setNewPw]      = useState("");
  const [confirmPw,  setConfirmPw]  = useState("");
  const [pwError,    setPwError]    = useState("");
  const [pwSuccess,  setPwSuccess]  = useState("");
  const [pwLoading,  setPwLoading]  = useState(false);

  useEffect(()=>{

    async function load(){
      const userSnap = await getDoc(doc(db, "users", auth.currentUser.uid));
      const data = userSnap.data();
      if(!data.householdId) return;
      const houseSnap = await getDoc(doc(db, "households", data.householdId));
      setHousehold(houseSnap.data());
    }

    load();

  },[]);

  async function handleChangePassword(){
    setPwError("");
    setPwSuccess("");

    if(!currentPw || !newPw || !confirmPw){
      setPwError("Please fill in all fields.");
      return;
    }
    if(newPw !== confirmPw){
      setPwError("New passwords do not match.");
      return;
    }
    const missing = validatePassword(newPw);
    if(missing.length > 0){
      setPwError(`New password must contain: ${missing.join(", ")}.`);
      return;
    }

    setPwLoading(true);
    try{
      await changePassword(currentPw, newPw);
      setPwSuccess("Password updated successfully.");
      setCurrentPw(""); setNewPw(""); setConfirmPw("");
    } catch(err){
      if(err.code === "auth/wrong-password" || err.code === "auth/invalid-credential"){
        setPwError("Current password is incorrect.");
      } else {
        setPwError("Failed to update password. Please try again.");
      }
    } finally {
      setPwLoading(false);
    }
  }

  return(

    <div>

      <div className="card">

        <h2 style={{marginTop:0}}>Profile</h2>

        <p><strong>Email:</strong> {auth.currentUser.email}</p>

        {household && (
          <>
            <h3>Household</h3>
            <p><strong>Name:</strong> {household.name}</p>
            <p><strong>Invite Code:</strong> <code className="householdCode">{household.code}</code></p>
          </>
        )}

      </div>

      <div className="card">

        <h3 style={{marginTop:0}}>Change Password</h3>

        {pwSuccess && <p className="pwSuccess">{pwSuccess}</p>}
        {pwError   && <p className="error">{pwError}</p>}

        <div className="formGroup">
          <label>Current Password</label>
          <PasswordInput
            value={currentPw}
            onChange={e=>setCurrentPw(e.target.value)}
            style={{maxWidth:300}}
          />
        </div>

        <div className="formGroup">
          <label>New Password</label>
          <PasswordInput
            value={newPw}
            onChange={e=>setNewPw(e.target.value)}
            style={{maxWidth:300}}
          />
        </div>

        <div className="formGroup">
          <label>Confirm New Password</label>
          <PasswordInput
            value={confirmPw}
            onChange={e=>setConfirmPw(e.target.value)}
            style={{maxWidth:300}}
          />
        </div>

        <button onClick={handleChangePassword} disabled={pwLoading}>
          {pwLoading ? "Updating…" : "Update Password"}
        </button>

      </div>

    </div>

  );

}
